/* =========================================================
   JP: Open Mix&Match popup from URL param
   - If URL contains ?open_mixmatch=1
   - Clicks the real Fast Bundle "View offer details" button on PDP
   - Safe: runs once per page load
   ========================================================= */

(function () {
  const LOG = "[JP Open MixMatch]";
  const DEBUG = false;
  const log = (...a) => DEBUG && console.log(LOG, ...a);

  function hasParam() {
    try {
      const u = new URL(window.location.href);
      return u.searchParams.get("open_mixmatch") === "1";
    } catch (e) {
      return false;
    }
  }

  // Finds a clickable "View offer details" launcher button inside the hidden Fast Bundle widget
  function findFastBundleTrigger() {
    const candidates = [
      ".button_container_213f588e.button_primary_213f588e",
      '[id^="rbr-bundle-"] [class*="button_container_"]',
      '[id^="rbr-bundle-"] button',
      '[id^="rbr-bundle-"] div[role="button"]',
    ];

    for (const sel of candidates) {
      const els = Array.from(document.querySelectorAll(sel));
      for (const el of els) {
        const txt = (el.textContent || "").trim().toLowerCase();
        if (txt.includes("view offer details") || txt.includes("offer details")) {
          return el;
        }
      }
    }
    return null;
  }

  async function tryOpenOnce() {
    if (!hasParam()) return;
    if (window.__jp_mixmatch_opened) return;
    window.__jp_mixmatch_opened = true;

    log("Param detected. Trying to open Mix&Match…");

    const maxMs = 8000;
    const start = Date.now();

    while (Date.now() - start < maxMs) {
      const trigger = findFastBundleTrigger();
      if (trigger) {
        log("Trigger found. Clicking…", trigger);
        trigger.click();
        return;
      }
      await new Promise((r) => setTimeout(r, 250));
    }

    log("Could not find Fast Bundle trigger within timeout");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => setTimeout(tryOpenOnce, 300));
  } else {
    setTimeout(tryOpenOnce, 300);
  }
})();

/* =========================================================
   JP: Move nav inline with logo on desktop
   ========================================================= */
(function () {
  function moveNav() {
    const nav = document.querySelector('.site-nav.style--classic');
    const headerTop = document.querySelector('.header__top');
    const headerActions = document.querySelector('.header-actions');

    if (nav && headerTop && headerActions) {
      headerTop.insertBefore(nav, headerActions);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveNav);
  } else {
    moveNav();
  }
})();
